import React from "react";

export const RiskProfileIcon: React.FC = () => {
  return (
    <svg
      width="26px"
      height="26px"
      viewBox="0 0 26 26"
      style={{ margin: "0 7px" }}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <desc>Created with sketchtool.</desc>
      <g
        id="Page-1"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="CareGEM-Provider-Global-navigation-V2.3"
          transform="translate(-20.000000, -421.000000)"
        >
          <g
            id="images-menu-copy-43"
            transform="translate(14.000000, 415.000000)"
          >
            <g id="Risk-Profile-icon" transform="translate(7.000000, 7.000000)">
              <path
                d="M12,0 L12,0 C18.627417,-1.21743675e-15 24,5.372583 24,12 L24,12 C24,18.627417 18.627417,24 12,24 L12,24 C5.372583,24 8.11624501e-16,18.627417 0,12 L0,12 C-8.11624501e-16,5.372583 5.372583,1.21743675e-15 12,0 Z"
                id="Rectangle-Copy-220"
                stroke="#FFFFFF"
                strokeWidth="0.4"
                fill="#7CBA5B"
              ></path>
              <path
                d="M10.5713684,11.8664519 C11.0519885,11.8664519 11.5877537,11.9413015 12.1786801,12.0910028 C12.8405176,12.2564622 13.3762829,12.4770714 13.7859918,12.7528371 C14.2744909,13.0837558 14.5187368,13.4501247 14.5187368,13.8519546 L14.5187368,15.9608421 L6.624,15.9608421 L6.624,13.8519546 C6.624,13.4501247 6.8682459,13.0837558 7.35674504,12.7528371 C7.76645399,12.4770714 8.30221919,12.2564622 8.96405673,12.0910028 C9.5549831,11.9413015 10.0907483,11.8664519 10.5713684,11.8664519 Z M10.5713684,7.43452632 C10.9259242,7.43452632 11.2528986,7.52316394 11.5523013,7.70044185 C11.851704,7.87771976 12.0900407,8.11999594 12.2673186,8.42727766 C12.4445965,8.73455937 12.5332342,9.06547317 12.5332342,9.42002899 C12.5332342,9.77458482 12.4445965,10.1015592 12.2673186,10.4009619 C12.0900407,10.7003646 11.851704,10.9387013 11.5523013,11.1159792 C11.2528986,11.2932571 10.9259242,11.3818947 10.5713684,11.3818947 C10.2168126,11.3818947 9.88983824,11.2932571 9.59043555,11.1159792 C9.29103286,10.9387013 9.05269613,10.7003646 8.87541822,10.4009619 C8.6981403,10.1015592 8.60950268,9.77458482 8.60950268,9.42002899 C8.60950268,9.06547317 8.6981403,8.73455937 8.87541822,8.42727766 C9.05269613,8.11999594 9.29103286,7.87771976 9.59043555,7.70044185 C9.88983824,7.52316394 10.2168126,7.43452632 10.5713684,7.43452632 Z M10.5713684,12.8119294 C10.1222644,12.8119294 9.64559092,12.8789001 9.14133375,13.0128434 C8.70798775,13.1310286 8.33767944,13.2728488 8.03039773,13.4383082 C7.72311602,13.6037676 7.56947747,13.7416484 7.56947747,13.8519546 L7.56947747,15.0153646 L13.5732594,15.0153646 L13.5732594,13.8519546 C13.5732594,13.7416484 13.4196208,13.6037676 13.1123391,13.4383082 C12.8050574,13.2728488 12.4347491,13.1310286 12.0014031,13.0128434 C11.4971459,12.8789001 11.0204725,12.8119294 10.5713684,12.8119294 Z M10.5713684,8.38000378 C10.2798447,8.38000378 10.0336291,8.48045976 9.83271415,8.68137472 C9.63179918,8.88228969 9.53134321,9.12850532 9.53134321,9.42002899 C9.53134321,9.71155267 9.63179918,9.95382885 9.83271415,10.1468648 C10.0336291,10.3399007 10.2798447,10.4364173 10.5713684,10.4364173 C10.8628921,10.4364173 11.1091077,10.3399007 11.3100227,10.1468648 C11.5109377,9.95382885 11.6113936,9.71155267 11.6113936,9.42002899 C11.6113936,9.12850532 11.5109377,8.88228969 11.3100227,8.68137472 C11.1091077,8.48045976 10.8628921,8.38000378 10.5713684,8.38000378 Z"
                id=""
                stroke="#FFFFFF"
                strokeWidth="0.4"
                fill="#FFFFFF"
              ></path>
              <path
                d="M14.5263158,13.6315789 L14.5263158,15.5263158 L17.0526316,15.5263158 L17.0526316,13.6315789 L14.5263158,13.6315789 Z M13.5789474,12.6842105 L18,12.6842105 L18,16.4736842 L13.5789474,16.4736842 L13.5789474,12.6842105 Z"
                id="Rectangle"
                fill="#FFFFFF"
              ></path>
              <path
                d="M14.7565125,12.7735947 L13.8091441,12.7735947 C13.8091441,11.9436885 14.3764573,11.125583 15.3740027,10.9739939 C16.1231846,10.8601465 16.7760919,11.1130675 17.2756138,11.7058109 L16.5511837,12.316309 C16.2619378,11.9730836 15.9360244,11.8468324 15.5163328,11.9106096 C15.0278959,11.9848335 14.7565125,12.3761875 14.7565125,12.7735947 Z"
                id="Path-2"
                fill="#FFFFFF"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};
